<template>
  <div class="app-container">
    <PageRoute />
    <div class="banner">
      <div class="b-left">
        <img v-if="leftBannerUrl" :src="leftBannerUrl" alt="" />
        <el-empty
          style="width: 100%"
          :image-size="140"
          v-else
          description="虚位以待"
        />
      </div>
      <div class="b-right">
        <el-carousel
          height="510px"
          @change="handleCarouseChange"
          v-if="sceneList.length > 0"
        >
          <el-carousel-item v-for="scene in sceneList" :key="scene.sceneId">
            <div class="r-focus" @click="toSceneDetail(scene)">
              <img :src="scene.carouselImg" alt="" />
              <p class="r-f-name">{{ scene.sceneName }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="r-empty" v-else>
          <el-empty
            style="width: 100%"
            :image-size="140"
            description="虚位以待"
          />
        </div>
      </div>
    </div>
    <div class="goods">
      <template v-if="goodsList.length > 0">
        <Goods
          class="d-one"
          v-for="item in goodsList"
          :key="item.spuId"
          :item="item"
        />
      </template>
      <el-empty
        style="width: 100%"
        :image-size="140"
        v-else
        description="专家推荐中，敬请期待"
      />
    </div>
  </div>
</template>

<script>
import Goods from './components/Goods'
import PageRoute from './components/pageRoute'

export default {
  components: {
    Goods,
    PageRoute
  },
  data () {
    return {
      goodsList: [],
      sceneList: [],
      carouseI: 0,
      leftBannerUrl: null
    }
  },
  mounted () {
    this.getScene()
    this.getLeftUrl()
  },
  computed: {
    presentScene () {
      return this.sceneList[this.carouseI]
    }
    // leftBannerUrl () {
    //   let list = getDictDataList('COMMODITY_SCENE_LECTOTYPE_SIDE_PICTURE')
    //   console.log(list)
    //   return list.length > 0 ? list[0].value : null
    // }
  },
  methods: {
    getLeftUrl () {
      setTimeout(() => {
        let list =
          window.SITE_CONFIG['dictList'][
            'COMMODITY_SCENE_LECTOTYPE_SIDE_PICTURE'
          ]
        if (!list) this.getLeftUrl()
        else this.leftBannerUrl = list[0].value
      }, 300)
    },
    toSceneDetail (scene) {
      this.$router.push('/sceneSelectionScene?sceneId=' + scene.sceneId)
    },
    handleCarouseChange (i) {
      this.carouseI = i
      this.getSku()
    },
    getScene () {
      this.$http
        .post(`/front/cross/commodity-user/queryPage`, {
          limit: 100000,
          page: 1,
          statusList: ['1']
        })
        .then(({ data: res }) => {
          this.sceneList = res.data.dataList
          console.log(this.sceneList)
          this.getSku()
        })
    },
    getSku () {
      this.$http
        .post(`/front/cross/commodity-user/getSpuList`, {
          sceneId: this.presentScene.sceneId
        })
        .then(({ data: res }) => {
          this.goodsList = res.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  max-width: 1200px;
  width: 1200px;
  margin: 0 auto;
  .banner {
    width: 100%;
    height: 510px;
    display: flex;
    margin-bottom: 16px;
    .b-left {
      width: 280px;
      height: 100%;
      flex-shrink: 0;
      margin-right: 12px;
      background-color: #fff;
      border-radius: 12px;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .b-right {
      height: 100%;
      flex-grow: 1;
      background-color: #fff;
      border-radius: 12px;
      //   display: flex;
      //   align-items: center;
      .r-focus {
        height: 100%;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .r-f-name {
          position: absolute;
          left: 50%;
          bottom: 28px;
          transform: translateX(-50%);
          height: 29px;
          line-height: 29px;
          border-radius: 8px;
          padding: 0 8px;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          margin: 0;
        }
      }
      .r-empty {
        display: flex;
        align-items: center;
        height: 100%;
      }
    }
  }
  .goods {
    --columns: 4;
    --gap: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: var(--gap);
    min-height: 300px;
    .d-one {
      --goodsWidth: calc(
        (100% - (var(--columns) - 1) * var(--gap)) / var(--columns)
      );
      width: var(--goodsWidth);
    }
  }
}
</style>
